/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { AviNotificationType, IAviNotificationAction } from 'ng/modules/notification/avi-notification.types';
import * as l10n from './license-tier-switch-notification.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for displaying license tier switch success notification with Edit Settings link.
 * @author Shubham Bindal
 */
@Component({
    selector: 'license-tier-switch-notification',
    templateUrl: './license-tier-switch-notification.component.html',
})
export class LicenseTierSwitchNotificationComponent implements OnInit {
    /**
     * Licensing type label to display in the message.
     */
    @Input()
    public licensingTypeLabel = '';

    /**
     * Handler to open license tier change modal.
     */
    @Output()
    public readonly onEditSettingsClick = new EventEmitter<void>();

    /**
     * Called when the notification should be closed.
     */
    @Output()
    public readonly onClose = new EventEmitter<void>();

    /**
     * Notification type, set to "success".
     */
    public notificationType = AviNotificationType.SUCCESS;

    /**
     * Action as the clickable links in the notification.
     * Contain "Edit Settings" action.
     */
    public actions: IAviNotificationAction[];

    public readonly l10nKeys = l10nKeys;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.actions = [{
            label: this.l10nService.getMessage(l10nKeys.editSettingsLabel),
            onClick: this.handleEditSettingsClick.bind(this),
        }];
    }

    /**
     * Handle Edit Settings action click.
     */
    public handleEditSettingsClick(): void {
        this.onEditSettingsClick.emit();
    }

    /**
     * Close handler for closing the notification.
     */
    public handleClose(): void {
        this.onClose.emit();
    }
}
